module.exports = __webpack_public_path__ + "img/scenario_office_icon.de60c729.png";